<template>
  <div>
    <h1 class="page-header">{{ $t('room.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'room-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-branch-filter @filter="value => (branch_id = value)" />
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              style="width: 300px;"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>
            {{ record.branch !== null ? record.branch.branch_name_en : '' }}
          </td>
          <td>{{ record.room_name }}</td>
          <td>{{ record.capacity }}</td>
          <td>
            {{ record.room_type !== null ? record.room_type.room_type : '' }}
          </td>
          <td>{{ record.floor_no }}</td>
          <td>
            {{ record.building !== null ? record.building.building_name : '' }}
          </td>
          <td>{{ $store.getters.limitStringShow(record.room_desc) }}</td>
          <td class="text-center">
            <a
              href="#"
              title="Edit"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              title="Delete"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'room',
  data() {
    return {
      loading: false,
      branch_id: [],
      columns: [
        { name: this.$t('room.branch') },
        { name: this.$t('room.name') },
        { name: this.$t('room.capacity') },
        { name: this.$t('room.roomtype') },
        { name: this.$t('room.floor') },
        { name: this.$t('room.building') },
        { name: this.$t('room.description') },
        { name: this.$t('room.actions'), style: 'text-align:center; width:1px' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('room', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.room.search
      },
      set(newValue) {
        this.$store.commit('room/SET_SEARCH', newValue)
        this.$store.commit('room/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'room/fetch',
          Object.assign({}, attributes, { branch_id: this.branch_id })
        )
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('room/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'room-edit',
        params: { id: record.room_id }
      })
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('room/destroy', record.room_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'room-create') {
      this.$store.commit('room/RESET_STATE')
      this.$store.commit('room/SET_FOUND_DATA', {})
      this.$store.commit('room/SET_BUILDINGS', [])
      this.$store.commit('room/SET_ROOM_TYPES', [])
    }
    next()
  }
}
</script>
